/// <reference path="../app.ts" />
namespace Cfnc {
    "use strict";

    interface ISubmitOrder { }

    class Address implements IAddress {
        addressType: string;
        firstName: string;
        lastName: string;
        street: string;
        street2: string;
        city: string;
        state: string;
        postalCode: string;
        country: string;
        county: string;
        isVerified: boolean;
        resultCodes: string;
        userOverride: boolean;
        signature: string;
        key: string;
    }

    interface IOrderItem {
        itemName: string;
        quantity: string;
    }

    class Order {
        firstName: string;
        lastName: string;
        organizationName: string;
        title: string;
        emailAddress: string;
        phoneNumber: string;
        mailingAddress: IAddress;
        items: IOrderItem[];
        recaptchaToken: string;
    }

    class SubmitOrder implements ISubmitOrder {

        static controllerId: string = "submitOrder";
        static $inject: Array<string> = ["common", "Restangular", "$location", "vcRecaptchaService"];
        log: (msg, data?, showToast?) => void;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;
        order: Order;
        complete: boolean;
        products: string[];
        newItem: IOrderItem;
        referenceCode: string;
        working: boolean;
        widgetId: string;

        constructor(private common: ICommonFactory, private Restangular: Restangular.IService, private $location: ng.ILocationService, private vcRecaptchaService) {
            this.log = common.logger.getLogFn(SubmitOrder.controllerId);
            this.logError = common.logger.getLogFn(SubmitOrder.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(SubmitOrder.controllerId, "success");

            this.activate();
            this.initializeOrder();


        }

        activate() {
            var promises = [this.getProducts()];
            this.common.activateController(promises, SubmitOrder.controllerId)
                .then(() => {
                    this.log("Activated Orders View");
                });
        }

        getProducts() {
            return this.Restangular.all("orders/products").getList().then(
                (result) => {
                    this.products = result;
                });
        }

        submit() {
            this.working = true;
            if (this.order.recaptchaToken == null || this.order.recaptchaToken == "") {
                this.vcRecaptchaService.execute(this.widgetId);
            } else {
                this.order.items = _.filter<any>(this.order.items, (x) => x.itemName && x.quantity);

                this.Restangular.all("orders/submit").post(this.order).then((response) => {
                    this.complete = true;
                    this.referenceCode = response;
                    this.initializeOrder();
                }, (reason) => {
                    this.logError("An error occurred submitting the order", reason.data, true);
                }).finally(() => {
                    this.order.recaptchaToken = null;
                    this.working = false;
                });
            }
        }

        addItem() {
            var last = this.order.items[this.order.items.length - 1];
            if (last !== null && last.itemName != "") {
                this.order.items.push({ itemName: "", quantity: null });
            }
        }

        initializeOrder() {
            this.order = new Order();
            this.order.mailingAddress = new Address();
            this.order.mailingAddress.state = "NC";
            this.order.mailingAddress.country = "US";
            this.order.items = [{ itemName: "", quantity: null }];
        }

        removeItem(index) {
            this.order.items.splice(index, 1);
        }


        recaptchaCreated = (widgetId): void => {
            this.widgetId = widgetId;

        };

        recaptchaExpired = (): void => {
            this.vcRecaptchaService.reload(this.widgetId);

        };

        recaptchaSuccess = (response): void => {
            this.order.recaptchaToken = response;
            this.submit();
        };

    }

    angular.module("app").controller(SubmitOrder.controllerId, SubmitOrder);
}